import StaticAlert from './StaticAlert';

export default StaticAlert;